/**
 * An invitation link opened while signed out: the token waits in the tab's session storage
 * (never localStorage, never a URL) until the user has signed in and lands on the join page.
 */
const KEY = 'zadok:join-token';

export function savePendingJoinToken(token: string): void {
  try {
    sessionStorage.setItem(KEY, token);
  } catch {
    // Storage unavailable: the user can paste the link again after signing in.
  }
}

export function readPendingJoinToken(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function clearPendingJoinToken(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
